import ExoForm from "../../../components/exo/ExoForm";
import { useTranslation } from "react-i18next";
import { API_POST, DBRequest, useConfig } from "../../../api/api";
import moment from "moment";
import { useState } from "react";
import * as Yup from "yup";

export const GenerateTimeSheets = ({ onResponse, onClose }) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  function createElement(data) {
    const reqData = {
      year: parseInt(data.year),
      month: parseInt(data.month),
    };
    DBRequest({
      config,
      path: "time-sheets/generate/all",
      method: API_POST(reqData),
      onResponse: onResponse,
      onLoading: setIsLoading,
    });
  }

  const fields = [
    {
      label: t("Year"),
      key: "year",
      type: "date",
      format: "YYYY",
      views: ["year"],
    },
    {
      label: t("Month"),
      key: "month",
      type: "date",
      format: "MM",
      views: ["month"],
    },
  ];
  const defaultValues = {
    year: moment().format("YYYY"),
    month: moment().format("MM"),
  };

  const validationSchema = Yup.object().shape({
    year: Yup.string().required(t("Is required")),
    month: Yup.string().required(t("Is required")),
  });

  return (
    <ExoForm
      startDataCollection={defaultValues}
      className="p-4 flex flex-col gap-4"
      header={t("Generate Timesheets")}
      fields={fields}
      onCancle={onClose}
      submitText={t("Generate")}
      onSubmit={createElement}
      isLoading={isLoading}
      validationSchema={validationSchema}
      noDifferences
    />
  );
};
